import type { ChangeEvent } from "react";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { useFormContext } from "react-hook-form";
import { Form } from "@circle-react-shared/uikit/Form";
import { CORNERS } from "./constants";
import type { ButtonRadiusSelectorType } from "./constants";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { t } from "@/i18n-js/instance";

interface InputsProps {
  name: string;
  selectedRadius: ButtonRadiusSelectorType;
}

export const inputClassName =
  "border-primary bg-primary text-dark group-hover:border-darkest focus:border-darkest group-focus-within:border-darkest w-full appearance-none rounded-lg border px-3 py-2 text-center focus:!outline-none focus:!ring-0";

export const Inputs = ({ selectedRadius, name }: InputsProps) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();
  const { setValue } = useFormContext();

  const handleAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const newValues = {
      border_left_top_radius: value,
      border_left_bottom_radius: value,
      border_right_top_radius: value,
      border_right_bottom_radius: value,
    };

    setValue(name, newValues);
  };

  if (isPropertiesPanelV2) {
    if (selectedRadius === "all") {
      return null;
    }

    return (
      <div className="flex flex-row gap-2">
        {CORNERS.map(corner => (
          <div className="flex flex-col gap-2" key={corner}>
            <Form.Item
              isFirstChild
              hideBorder
              hideDescription
              name={`${name}.${corner}`}
              hideLabel
            >
              <Form.Input
                label={null}
                name={`${name}.${corner}`}
                type="number"
                min={0}
                className={inputClassName}
              />
            </Form.Item>
            <div className="flex flex-col items-center gap-1 text-center">
              <Typography.LabelXs color="text-tertiary" weight="medium">
                {t(["builder_ui.prop_type.styles", corner])}
              </Typography.LabelXs>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (selectedRadius === "all") {
    return (
      <Form.Item
        isFirstChild
        hideBorder
        hideDescription
        name={`${name}.border_left_top_radius`}
        label={null}
      >
        <Form.Input
          label={null}
          name={`${name}.border_left_top_radius`}
          type="number"
          min={0}
          className={inputClassName}
          onChange={handleAllChange}
        />
      </Form.Item>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      {CORNERS.map(corner => (
        <Form.Item
          key={corner}
          isFirstChild
          hideBorder
          hideDescription
          name={`${name}.${corner}`}
          label={null}
        >
          <Form.Input
            label={null}
            name={`${name}.${corner}`}
            type="number"
            min={0}
            className={inputClassName}
          />
        </Form.Item>
      ))}
    </div>
  );
};
